// extracted by mini-css-extract-plugin
module.exports = {"spinner":"TableActions_spinner__3CFDO"};